import { Components } from "@thisgorilla/primate-ds";
import { useTheme } from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import { useAppSelector } from "../../../../../redux";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { Slider } from "../../../../Common/Slider";
import { useFindContent } from "../../useFindContent";
import PreviewLayout from "../PreviewLayout";
import { PreviewContent } from "../style";
import SliderProps from "./Slider";
import { PreviewContentSlider } from "./style";

const SliderPreview = ({
  id,
  setIsSliderCreated,
}: SliderProps.SliderPreviewProps) => {
  const { typography } = useTheme();
  const { emojis } = useAppSelector((state) => state.me);
  const { content_data } = useFindContent(id) as ArticleProps.WithRatingContent;
  const { question, left_emoji_id, right_emoji_id } = content_data;

  return (
    <PreviewLayout
      onDelete={() => API_CALLS.ARTICLE.deleteASingleArticleContent(id)}
      onEdit={() => setIsSliderCreated(false)}
    >
      <PreviewContent>
        <Components.Text
          text={question}
          style={{ tokenStyle: typography.Body.L }}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-200"
        />
        <PreviewContentSlider>
          <Slider
            emojiValue={[
              emojis[left_emoji_id]?.name ?? "none",
              emojis[right_emoji_id]?.name ?? "none",
            ]}
          />
        </PreviewContentSlider>
      </PreviewContent>
    </PreviewLayout>
  );
};

export default SliderPreview;
